jQuery(function($) {

  //Virtually Maps clicks from our custom Share Icons to addThis Share Buttons
  //NOTE: We are using some vanilla JS in here specifically for compatability with addThis's JS
  $( document ).ready(function() {
    console.log('ready');
    $(".social_icon .social_icon__button").click(function(ev) {
      // console.log($elem);
      var $button    = $(ev.currentTarget);
      var buttonType = $button.attr('data-button-type');
      var elemList   = [];
      var baseClass  = window.addThisBaseClass || 'at-svc-';

      elemList = document.getElementsByClassName(baseClass + buttonType);

      console.log('virtual click: ' + baseClass + buttonType);
      console.log(elemList);

      if (elemList[0]) {
        simulateClick(elemList[0]);
      }
    });

    function simulateClick (elem) {
    	// Create our event (with options)
    	var evt = new MouseEvent('click', {
    		bubbles: true,
    		cancelable: true,
    		view: window
    	});
    	// If cancelled, don't dispatch our event
    	var canceled = !elem.dispatchEvent(evt);
    }
  });
});

jQuery(function($) {
  $(document).ready(function() {
    var $calendar    = $('.cmcal-calendar');
    var $listButton  = $('.fc-listMonth-button');
    var $loading     = $('.loading-spinner');
    var width        = getScreenWidth();
    var timer;
    var canLoad;

    if (!$calendar[0]) {
      return;
    }

    updateButtons();

    console.log('screen width: ' + width);

    function getScreenWidth() {
      return window.screen.width;
    }

    function waitForInit() {
      console.log('waitForInit');

      timer = setTimeout(function () {
        updateButtons();
      }, 250);
    }

    function updateButtons() {
      $listButton = $('.fc-listMonth-button');

      console.log('$listButton', $listButton[0]);

      if ($listButton[0]) {
        console.log('hasListButton');
        $listButton.text('List');
        $listButton.click();

        $('.events-calendar-wrap').removeClass('loading-state');
        $loading.hide();

        toolbarSync();

        var $mainToolbar  = $('.fc-toolbar').not('.toolbar-clone');

        $mainToolbar.on('click', function(){
          //TODO: Need actual event rather than timeout if possible

          setTimeout(function () {
            toolbarSync();
          }, 300);
        });
      }
      else {
        waitForInit();
      }
    }

    function toolbarSync() {
      $('.toolbar-clone').remove();

      var $mainToolbar  = $('.fc-toolbar').not('.toolbar-clone');
      var $cloneToolbar = $('.cmcal-calendar .fc-toolbar').clone();

      $cloneToolbar.addClass('toolbar-clone');
      $('.cmcal-calendar').append($cloneToolbar);

      $cloneToolbar = $('.toolbar-clone');

      var $clonePrev = $cloneToolbar.find('.fc-prev-button');
      var $cloneNext = $cloneToolbar.find('.fc-prev-next');
      var $cloneMonth = $cloneToolbar.find('.fc-dayGridMonth-button');
      var $cloneList = $cloneToolbar.find('.fc-listMonth-button');

      var $prev = $mainToolbar.find('.fc-prev-button');
      var $next = $mainToolbar.find('.fc-next-button');
      var $month = $mainToolbar.find('.fc-dayGridMonth-button');
      var $list = $mainToolbar.find('.fc-listMonth-button');

      triggerClick('.fc-prev-button');
      triggerClick('.fc-next-button');
      triggerClick('.fc-dayGridMonth-button');
      triggerClick('.fc-listMonth-button');

      function triggerClick(selector) {
        $cloneToolbar.find(selector).click(function() {
          $mainToolbar.find(selector).click();
        });
      }
    }
  });
});

jQuery(function($) {
  $(document).ready(function() {
    // Check for counter presence before running code
    if ($('.churchonline_counter').length) {
      newCountdown();
    }

    //TODO: Verify Timezones

    function newCountdown() {
      var countDownDate = new Date(window.nextEvent.special_event_time).getTime();

      // Update the count on init
      tick();

      // Update the count down every 1 second
      var tickInterval = setInterval(tick, 1000);

      function tick() {
        // Get todays date and time
        var nowTime  = new Date().getTime();
        var distance = countDownDate - nowTime;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // If the count down is finished, reload page
        if (distance < 0) {
          clearInterval(tickInterval);
          location.reload();
        }
        else {
          $('.churchonline_counter .days').html(function() {
            return ( (days < 10 ) ? ("0" + days) : days );
          });
          $('.churchonline_counter .hours').html(function() {
            return ( (hours < 10 ) ? ("0" + hours) : hours );
          });
          $('.churchonline_counter .minutes').html(function() {
            return ( (minutes < 10) ? ("0" + minutes) : minutes );
          });
          $('.churchonline_counter .seconds').html(function() {
            return ( (seconds < 10) ? ("0" + seconds) : seconds );
          });
        }
      }
    }
  });
});

jQuery(function($)
{
    disableStaffSliderClicks();

    function disableStaffSliderClicks() {
      $('.missionary-slider .fl-post-carousel-post a').click(function (ev) {
        var $card     = $(ev.currentTarget);
        console.log('disableStaffSliderClicks' + ev.currentTarget);
        ev.preventDefault();
      });
    }
});

jQuery(function($) {

  initSiteHiddenMenu();

  function initSiteHiddenMenu() {
    //Toggle's initial state must be toggle-closed
    $('.toggle-hidden-menu').on('click', function() {
        if(!$(this).hasClass('toggle-opened')){
          $main_menu = $($('.navbar__container')[0]);
          menu_height = $main_menu.offset().top + $main_menu.height();
          // console.log(menu_height);
          $('.hidden-menu').css('top', menu_height);
          $(this).addClass('toggle-opened').removeClass('toggle-closed');
          $('body, html').addClass('body-is-mobile');
          $('.hidden-menu.closed').addClass('opened').removeClass('closed');
        }
        else{
          $(this).addClass('toggle-closed').removeClass('toggle-opened');
          $('body, html').removeClass('body-is-mobile');
          $('.hidden-menu.opened').addClass('closed').removeClass('opened');
        }
        // $('.mobile-nav-background').toggleClass('is-mobile');
        // $('.mobile-nav-hamburger').toggleClass('mobile-burger');
        // // $('.burger_text').toggle(200);
        // $('.burger').toggleClass('burger-x');
        // $('.mobile-nav-menu-links').toggleClass('mobile-links-visible');
    });

    $('.navbar--hidden .menu-item-has-children .fl-menu-toggle').on('click', function (e) {
        $this = $(this);
        $submenu = $this.parent().siblings('.sub-menu');
        if(!$this.hasClass('toggle-opened')){
          $this.addClass('toggle-opened').removeClass('toggle-closed');
          scrollHeight = $submenu[0].scrollHeight;
          $submenu.css( "max-height", scrollHeight );

        }else{
          $this.addClass('toggle-closed').removeClass('toggle-opened');
          $submenu.css( "max-height", "0" );
          console.log('submenu closed');
        }
        // e.preventDefault();
        // $('.mobile-nav-menu .menu-item-has-children').not($(this).parent()).removeClass('mobile-show-submenu');
        // $(this).parent().toggleClass('mobile-show-submenu');
    });
  }

});

jQuery(function($)
{
    modalCardOpen();

    function modalCardOpen() {
      $('.modal-card').click(function (ev) {
        var $card     = $(ev.currentTarget);
        var modal_id  = $card.attr('modal-id');
        var content   = $('.modal-card__modal[modal-id="' + modal_id + '"]');

        console.log('slug', '.modal-card__modal[modal-id="' + modal_id + '"]');
        console.log(content.text());

        setTimeout(function () {
          $.magnificPopup.open({
            removalDelay: 0,
            closeBtnInside: true,
            showCloseBtn: true,
            overflowY: 'scroll',
            items: {
              src: content
            },
            type: 'inline'
          });
        }, 100);
      });
    }
});

jQuery(function($) {

  initSiteSearch();

  function initSiteSearch() {
    $('.open-search').on('click', function() {
      var $content = $('.hidden-modal--search .search-form');

      setTimeout(function () {
        $.magnificPopup.open({
          removalDelay: 0,
          closeBtnInside: true,
          showCloseBtn: true,
          overflowY: 'scroll',
          mainClass: 'modal__wrapper',
          items: {
            src: $content
          },
          type: 'inline'
        });
      }, 100);

      return false;
    });
  }

});

jQuery(function($) {
  $(document).ready(function() {
    var $contentLoader  = $('.content-loader-section');
    var $contentSection = $contentLoader.find('.cls-content');
    var $templates      = $('.content-loader-templates');
    var state = {
      pageNumber: 1,
      type: 'sermons',
      filters: {
      }
    };
    var viewBy = {
      'sermons': 'MOST RECENT',
      'sermon-series': 'SERMON SERIES',
      'core-series': 'CORE SERIES',
      'teachings': 'TEACHINGS',
      'outreach-trips': 'OUTREACH TRIPS',
      'service-opportunities': 'SERVICE OPPORTUNITIES',
      'events' : 'EVENTS',
      'groups' : 'SMALL GROUPS'
    };
    //TODO: Move these server side
    var $typeInputs = $('.cls-top_left .cls-content-type_inputs');

    //console.log('clsData', clsData);
    //console.log('clsOptions', clsOptions);
    //TODO: Validate Data and Templates

    if (!$contentLoader[0] || !window.clsData || !window.clsOptions) {
      // $contentSection.html('<p>Nothing to show</p>');
      return;
    }

    if (clsOptions.filters) {
      window.clsOptions.filters.forEach(function (contentFilter) {

      });
    }

    if (clsOptions.defaultType) {
      state.type = clsOptions.defaultType;
    }

    console.log('window.clsData', window.clsData);

    var first_active_key = false;

    if (Object.keys(window.clsData).length > 1) {
      Object.keys(window.clsData).forEach(function (key) {
        var label = viewBy[key];

        console.log('viewBy', viewBy);
        console.log('key', key);
        console.log('label', label);

        if(!first_active_key){
          first_active_key = key;
        }

        console.log('append View By: ' + label);

        $typeInputs.append('<div class="cls-content-type_input-wrapper"><a href="javascript:void(0)" class="cls-content-type_input" content-type="' + key + '">' + label + '</a></div>');
      });

    }
    else {
      console.log('hide top left');
      $('.cls-top_left').hide();
    }

    if (!state.type || !(window.clsData && window.clsData[state.type])) {
      state.type = first_active_key;
    }

    loadContent();

    //---Core Functions-----------------

    function loadContent() {
      console.log('loadContent');

      $contentSection.empty();
      $contentSection.attr('class','cls-content cls-content_' + state.type);

      $('.cls-content-type_inputs .active-input').removeClass('active-input');
      $('.cls-content-type_inputs a[content-type="' + state.type + '"]').addClass('active-input');

      //TODO: Loading States

      var data       = window.clsData[state.type];
      var showCats   = false;
      var catOptions = {};
      var selectStr;

      window.clsOptions.filters.forEach(function(filterCat) {
        catOptions[filterCat.slug] = {
          label: filterCat.label,
          categories: [],
          categorySlugs: [],
          presetValues: false
        };

        if (filterCat.values) {
          catOptions[filterCat.slug].presetValues  = true;
          catOptions[filterCat.slug].categorySlugs = Object.keys(filterCat.values);

          catOptions[filterCat.slug].categorySlugs.forEach(function (x) {
            catOptions[filterCat.slug].categories.push({
              slug: x,
              name: filterCat.values[x]
            });
          });
        }
      });

      console.log('loadContent: ' + state.type, data);

      data.forEach(function (item) {
        var $clone = $templates.find('.cls-card_' + state.type).clone();
        var catKeys = Object.keys(catOptions);

        catKeys.forEach(function(catKey) {
          var catString = '';
          var catOption = catOptions[catKey];
          var itemCats  = item[catKey];

          // If Item has category data
          if (itemCats && itemCats[0]) {

            // Serialize item categories into string
            itemCats.forEach(function(cat) {
              catString = catString + (cat.slug || cat) + ' ';

              if (!catOption.presetValues && catOption.categorySlugs.indexOf(cat.slug) < 0) {
                catOption.categories.push(cat);
                catOption.categorySlugs.push(cat.slug);
              }
            });
          }

          $clone.attr('cls-' + catKey, catString);
        });

        getAttrElem($clone, 'url').attr('href', item.url);
        getAttrElem($clone, 'image').attr('src', item.image);
        getAttrElem($clone, 'background').attr('style', 'background-image:url(' + item.image + ');');
        getAttrElem($clone, 'title').html(item.title);
        getAttrElem($clone.find('.cls-card_lower'), 'date').text(item.date || '');
        getAttrElem($clone.find('.cls-meta'), 'date').attr('cls-date', item.date);
        getAttrElem($clone, 'speaker').attr('cls-speaker', item.speaker);

        $clone.find('.cls-card_subtext').text(item.subtext);

        $contentSection.prepend($clone);
      });

      console.log('catOptions filled', catOptions);

      Object.keys(catOptions).forEach(function(catKey) {
        var catOption = catOptions[catKey];

        if (catOption.categories.length > 0) {
          selectStr = '<div class="cls-select-wrap"><strong>' + catOption.label + '</strong><select class="cls-select" cat-type="' + catKey + '">';

          selectStr += '<option value="" disabled>' + catOption.label  +'</option>';
          selectStr += '<option value="" selected>All</option>';

          catOption.categories.forEach(function(cat) {
            selectStr += '<option value="' + cat.slug + '">' + cat.name + '</option>';
          });

          selectStr += '</select></div>';

          $('.cls-top_right').append(selectStr);
        }
      });

      if ($('.cls-top_right select').length < 1) {
        $('.cls-top_right').hide();
      }

      //Display error message if no content is retrieved
      if($contentSection.html() == ''){
        $contentSection.addClass('cls-content_empty');
      }

      updateControls();

      function getAttrElem($baseElem, attrSlug) {
        return $baseElem.find('[cls-' + attrSlug + ']');
      }
    }

    //---Hooks-----------------------

    function typeChangeHook(ev) {
      var contentType = $(ev.currentTarget).attr('content-type');

      changeType(contentType);
    }

    function filterChangeHook(ev) {
      //TODO: These may not end up being actual attributes
      var $target   = $(ev.currentTarget);
      var filterType = $target.attr('filter-type');
      var filterVal  = $target.attr('filter-value');
    }

    function initSelect() {
      $('.cls-select').off('change', selectChangeHook).on('change', selectChangeHook);
    }

    function selectChangeHook(ev) {
      var str         = '';
      var $selects    = $('.cls-select');

      $selects.each(function (i, elem) {
        var $select = $(elem);
        var value   = $select.val();
        var attr    = $select.attr('cat-type');

        if (value && value !== '') {
          str += '[cls-' + attr + '~="' + value + '"]';
        }
      });

      console.log('select value', str);

      var $selected   = $('.cls-content').find('.cls-card' + str);
      var $unselected = $('.cls-content').find('.cls-card').not($selected);

      console.log('$selected', $selected);
      console.log('$unselected', $unselected);

      $selected.show();
      $unselected.hide();

      if ($selected.length > 0) {
        hideEmptyMessage();
      }
      else {
        showEmptyMessage();
      }
    }

    function pageClickHook(ev) {
      var pageNumber = $(ev.currentTarget).attr('page-number');

      changePage(pageNumber);
    }

    function prevPageHook(ev) {
      //TODO: Validate >= 1
      changePage(state.page - 1);
    }

    function nextPageHook(ev) {
      changePage(state.page + 1);
    }

    //---Update Functions-------------

    function showEmptyMessage() {
      console.log('showEmptyMessage');
      $('.content-loader-section').addClass('content-empty');
    }

    function hideEmptyMessage() {
      console.log('hideEmptyMessage');
      $('.content-loader-section').removeClass('content-empty');
    }

    function changeType(contentType) {
      state.type       = contentType
      state.pageNumber = 1;

      loadContent();
    }

    function filterContent(filterType, filterValue) {
      if (state[filterType]) {
        state[filterType] = filterValue;
        state.pageNumber  = 1;

        loadContent();
      }
    }

    function changePage(pageNumber) {
      state.pageNumber = pageNumber;

      loadContent();
    }

    //---Utility Functions-------------

    function updateControls() {
      initHandlers();
    }

    function initHandlers() {
      initHandler('.cls-content-type_input', typeChangeHook);
      initHandler('.filter-dropdown', filterChangeHook);
      initHandler('.page-number-button', pageClickHook);
      initHandler('.prev-button', prevPageHook);
      initHandler('.next-button', nextPageHook);

      initSelect();

      function initHandler(selector, callback) {
        $contentLoader.find(selector).off('click', callback);
        $contentLoader.find(selector).on('click', callback);
      }
    }
  });
});
